var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcNavProfile = function SvgIcNavProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_profile")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeOpacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3918176,24 L20.9032858,20.1195194 C20.332376,18.8330452 19.104318,17.9611958 17.7015383,17.8464659 L7.38479618,17.8464659 C5.98143764,17.9596062 4.75264862,18.8319746 4.18304864,20.1195194 L2.69451688,24 L0.176183291,24 L2.01110294,19.2001872 C2.91890595,17.0002208 5.00855509,15.5163515 7.38479618,15.3843033 L17.7015383,15.3843033 C20.0760545,15.5141085 22.1638653,16.9988954 23.0658697,19.1992511 L24.909215,23.9990638 L22.3918176,24 Z M6.01796828,6.87158683 C5.93043619,3.17529181 8.84728766,0.103600309 12.5431672,0 C16.2390468,0.103600309 19.1558982,3.17529181 19.0683662,6.87158683 C19.1558982,10.5678818 16.2390468,13.6395734 12.5431672,13.7431737 C8.84728766,13.6395734 5.93043619,10.5678818 6.01796828,6.87158683 Z M8.35842701,6.87158683 C8.30024754,9.24347361 10.1714946,11.2156089 12.5431672,11.2819473 C14.9148398,11.2156089 16.7860869,9.24347361 16.7279074,6.87158683 C16.7860869,4.49970005 14.9148398,2.52756472 12.5431672,2.4612264 C10.1714946,2.52756472 8.30024754,4.49970005 8.35842701,6.87158683 Z",
    id: "ic_profile",
    stroke: "#000000",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcNavProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_nav_profile.8966e14b.svg";
export { ForwardRef as ReactComponent };